import {
  CompetencesType,
  ParsedCompetence,
  MapedCompetencesType,
} from './utils';

export enum CompetencesStatusEnum {
  GET_EVENT_COMPETENCES = 'competences/get',
  GET_EVENT_COMPETENCE = 'competence/get',
}

export interface GetCompetences {
  data: CompetencesType;
}

export interface PromiseCompetences {
  data: MapedCompetencesType;
  filtered?: number;
}

export interface PromiseCompetence {
  data: ParsedCompetence;
}



// WEBPACK FOOTER //
// ./src/services/api/competences/types.ts